import React from 'react';
import PropTypes from 'prop-types';
import { sendLoyaltyModalEvent } from 'common/util/gtm-helper';
import Button from 'common/components/atoms/button';
import defaultStyles from 'commonStyles/components/coupon/_loyalty-simplified';
import styleOverrides from 'styles/components/coupon/_loyalty-simplified';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import { translate } from 'common/localization';
import ErrorBox from './coupon-error-box';

const LoyaltyCouponSimplifiedNewUser = ({
  couponId,
  claimCoupon,
  isLoading,
  error,
  disclaimers,
  onSignInClick,
}) => {
  const styles = useStyleOverrides(defaultStyles, styleOverrides);
  const siteAbbr = BC.site.code === 'competitivecyclist' ? 'cc' : 'bc';

  // TODO: this needs to be redefined on the tracking story
  // useEffect(() => {
  //   if (!isEmpty(errors)) {
  //     Object.keys(errors).forEach((key) => {
  //       sendLoyaltyModalEvent('error', `unrecognized|${errors[key].message}`);
  //     });
  //   }
  // }, [formState, errors]);

  const handleClick = () => {
    sendLoyaltyModalEvent('join now click', 'unrecognized');
    claimCoupon(couponId);
  };

  const hasError = Object.keys(error).length > 0;

  return (
    <>
      {hasError ? (
        <ErrorBox title={error.title} description={error.description} className={styles.errorBox} />
      ) : null}
      <Button className={styles.modalJoinBtn} primary disabled={isLoading || hasError} onClick={handleClick}>
        {isLoading ? (
          <div className="loading-primary" />
        ) : (
          <span>{translate('label.joinPerks')}</span>
        )}
      </Button>
      <div className={styles.disclaimer}>
        <span className={styles.disclaimerText}>
          {`${translate('newuser.terms.intro')} `}
          <a className={styles.modalLink} href="sc/terms-of-use" target="_blank" rel="noopener noreferrer">{translate('label.terms.use')}</a>
          {`, ${translate('label.expedition.perks')} `}
          <a className={styles.modalLink} href={`/sc/${siteAbbr}-expedition-perks-loyalty-program-terms-conditions`} target="_blank" rel="noopener noreferrer">{`${translate('label.terms.conditions')}`}</a>
          {`, ${translate('label.new.user.consent')} `}
          <a className={styles.modalLink} href="sc/privacy-policy" target="_blank" rel="noopener noreferrer">{`${translate('label.privacy.policy')} .`}</a>
        </span>
      </div>

      <div className={styles.hDivider} />

      <div className={styles.disclaimer}>
        <span className={styles.disclaimerText}>
          {disclaimers.notRecognized}
        </span>
      </div>

      <div className={styles.footerTextWrapper}>
        <p className={styles.footerText}>{translate('label.loyalty.coupon.haveAccountQuestion')}</p>
        <Button className={`${styles.modalMutedLink} js-login-modal`} onClick={onSignInClick} reset>{translate('label.loyalty.coupon.signIn')}</Button>
      </div>
    </>
  );
};

LoyaltyCouponSimplifiedNewUser.propTypes = {
  claimCoupon: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.shape({}).isRequired,
  disclaimers: PropTypes.shape({}).isRequired,
  onSignInClick: PropTypes.func.isRequired,
};

export default LoyaltyCouponSimplifiedNewUser;
